function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import React from 'react';
import _ from 'lodash';
import gettext from 'js-utils/gettext';
import { ANCHOR_LINK, DIVIDER } from '../navListItem/constants';
import UserChunkySvg from '../iconography/icons/UserChunky';
import VerticalDotsChunkySvg from '../iconography/icons/VerticalDotsChunky';
var DIVIDER_MENU_ITEM = {
  type: DIVIDER
};

var _quickLinkToMenuItem = function _quickLinkToMenuItem(_ref) {
  var content = _ref.content,
      url = _ref.url;
  return {
    type: ANCHOR_LINK,
    path: url,
    content: content
  };
};

var _menuInfoToMenuItem = function _menuInfoToMenuItem(_ref2) {
  var label = _ref2.label,
      fallbackUrl = _ref2.fallbackUrl;
  return {
    type: ANCHOR_LINK,
    path: fallbackUrl,
    content: label
  };
};

var _filterOutItemWithNarrowIcon = function _filterOutItemWithNarrowIcon(_ref3) {
  var narrowIconType = _ref3.narrowIconType;
  return !narrowIconType;
};

var _getUserNarrowMenuInfo = function _getUserNarrowMenuInfo(userMenuInfo, additionalMenuItems) {
  var navItems = userMenuInfo.navItems;

  if (!_.isEmpty(additionalMenuItems)) {
    navItems = [].concat(_toConsumableArray(navItems), [DIVIDER_MENU_ITEM], _toConsumableArray(additionalMenuItems));
  }

  return _objectSpread({
    iconType: React.createElement(UserChunkySvg, null),
    iconColor: 'grey-700',
    className: 'eds-global-header__user-menu'
  }, userMenuInfo, {
    navItems: navItems
  });
};

var _getFallbackNarrowMenuInfo = function _getFallbackNarrowMenuInfo(additionalMenuItems, nonUserQuickLinks, callToActionInfo) {
  var navItems = additionalMenuItems;
  var menuInfo;

  if (!_.isEmpty(nonUserQuickLinks)) {
    var nonUserQuickLinksAsMenuItems = nonUserQuickLinks.map(_quickLinkToMenuItem);
    navItems = [].concat(_toConsumableArray(navItems), [DIVIDER_MENU_ITEM], _toConsumableArray(nonUserQuickLinksAsMenuItems));
  }

  if (callToActionInfo) {
    navItems = [].concat(_toConsumableArray(navItems), [DIVIDER_MENU_ITEM, _quickLinkToMenuItem(callToActionInfo)]);
  }

  if (!_.isEmpty(navItems)) {
    menuInfo = {
      fallbackUrl: '#',
      label: gettext('Menu'),
      iconType: React.createElement(VerticalDotsChunkySvg, null),
      navItems: navItems
    };
  }

  return menuInfo;
};

export var getNarrowMenuInfo = function getNarrowMenuInfo(userMenuInfo) {
  var additionalMenus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var nonUserQuickLinks = arguments.length > 2 ? arguments[2] : undefined;
  var callToActionInfo = arguments.length > 3 ? arguments[3] : undefined;
  var quickLinks = arguments.length > 4 ? arguments[4] : undefined;
  var shouldCollapseToSingleMenu = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var narrowMenuInfo; // Some headers require flexiblility with the number of menus they display depending if the user is signed in or not
  // here we are checking if this is a case where a single menu is desired and show the appropriate menu depending
  // on the status of authentication (if `userMenuInfo` is supplied)
  // If the headers navigation links and menus `shouldCollapseToSingleMenu` then we will return an Object
  // Otherwise, based on the presence of `userMenuInfo`, we will either return a single Object or an Array of Objects for
  // the case in which we need to display two menus on narrow screens with the 'User Menu' containing ONLY the `userMenuInfo`

  if (shouldCollapseToSingleMenu) {
    var additionalMenusAsMenuItems = additionalMenus.filter(_filterOutItemWithNarrowIcon).map(_menuInfoToMenuItem);
    narrowMenuInfo = userMenuInfo ? _getUserNarrowMenuInfo(userMenuInfo, additionalMenusAsMenuItems) : _getFallbackNarrowMenuInfo(additionalMenusAsMenuItems, nonUserQuickLinks, callToActionInfo);
  } else {
    // We want to be able to display quickLinks and nonUserQuickLinks in the narrow menu
    // For this to work with _getFallbackNarrowMenuInfo's API we pass an
    // empty array to take the place of additionalMenus and combine quickLinks and nonUserQuickLinks
    narrowMenuInfo = _getFallbackNarrowMenuInfo([], [].concat(_toConsumableArray(quickLinks || []), _toConsumableArray(nonUserQuickLinks || [])));

    if (userMenuInfo) {
      narrowMenuInfo = [narrowMenuInfo, _getUserNarrowMenuInfo(userMenuInfo)];
    }
  }

  return narrowMenuInfo;
};